import { Select } from "antd";
import React from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { axios } from "../../../../utils/useAxios";
import { useMemo } from "react";
import { getUser } from "../../../../utils";

const { Option } = Select;

const SelectBranch = ({ ...props }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const user = useMemo(() => getUser(), []);

  const fetchBranchList = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`/requisition-branch/branch-online`, {
        params: {
          userBranchCode: user.branch_code,
        },
      });
      setData(data.branch);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [user]);
  useEffect(() => {
    fetchBranchList();
  }, [fetchBranchList]);
  return (
    <Select
      loading={loading}
      className="w-100"
      dropdownStyle={{ zIndex: 1080 }}
      {...props}
      value={data.length === 0 ? null : props.value}
    >
      {data.map((e) => (
        <Option key={e.code} value={e.code}>
          {e.name}
        </Option>
      ))}
    </Select>
  );
};

export default SelectBranch;
